// extracted by mini-css-extract-plugin
export var btn_auth_container = "auth-module--btn_auth_container--ZHsnh";
export var btn_auth_container_modal = "auth-module--btn_auth_container_modal--O0T8L";